import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgErrorModal',
})
export default class CmgErrorModal extends Vue {
  @Prop({ required: true, type: Boolean })
  visible!: boolean;

  @Prop({ required: false, default: 'beige-light', type: String })
  background?: string;

  @Prop({ required: false, default: false, type: Boolean })
  unmaskContent!: boolean;

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get manualWidth(): string | null {
    return this.isMobile ? null : '570px';
  }

  mounted() {
    document.addEventListener('keydown', this.tabModalOnFocusEventHandler);
  }
  destroyed() {
    document.body.removeEventListener('keyup', this.onClose);
  }

  @Watch('visible', { immediate: true, deep: true })
  async visibleChanged(newVisible: boolean) {
    if (newVisible) {
      this.$services.ui.firstFocus();
    }
  }
  tabModalOnFocusEventHandler(event: KeyboardEvent) {
    const classCheck = document.getElementsByClassName('error-modal');
    if (classCheck.length > 0) {
      const focusableEls = document.getElementsByClassName('error-modal')[classCheck.length - 1].querySelectorAll('[tabindex="0"]');
      const firstFocusableEl = focusableEls[0] as HTMLElement;
      const lastFocusableEl = focusableEls[focusableEls.length - 1] as HTMLElement;
      if (event.key === 'Tab' && event.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          event.preventDefault();
          (lastFocusableEl as HTMLElement).focus();
        } // Check for Tab
      } else if (event.key === 'Tab') {
        if (document.activeElement === lastFocusableEl) {
          event.preventDefault();
          (firstFocusableEl as HTMLElement).focus();
        }
      }
    }
  }

  onClose() {
    this.$emit('close');
  }
}
